<template>
  <div class="evaluateTag">
    <!-- 评分栏 -->
    <div class="evaluateTag-star">
      <!-- 标题 -->
      <span class="label">{{label}}：</span>
      <!-- 评分 -->
      <el-rate
        v-model="score"
        @change="scoreChange"
      ></el-rate>
    </div>
    <!-- 评分标签 -->
    <div class="evaluateTag-tags">
      <template v-for="(item, index) in lowTagValue">
        <div
          class="tagClass"
          :class="{activeTagClass: lowTagActive[index]}"
          :key="index"
          v-if="score === 1 || score === 2 || score === 3"
          @click="hanleclick('lowTagActive',index,item)"
        >{{item}}</div>
      </template>
      <template v-for="(item, index) in highTagValue">
        <div
          class="tagClass"
          :class="{activeTagClass: highTagActive[index]}"
          :key="index"
          v-if="score === 4 || score === 5 || score === 0"
          @click="hanleclick('highTagActive',index,item)"
        >{{item}}</div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: ['label', 'prop', 'tagValue'],
  data() {
    return {
      score: 0,
      lowTagValue: [],
      highTagValue: [],
      lowTagActive: [],
      highTagActive: [],
      selectValue: []
    }
  },
  methods: {
    // 选择标签
    hanleclick(name, index, code) {
      this.$set(this[name], index, !this[name][index])
      if (this.selectValue.indexOf(code) === -1) {
        this.selectValue.push(code)
      } else {
        _.remove(this.selectValue, function(n) {
          return n == code
        })
      }
      this.$emit('change', {
        [this.prop]: this.score,
        tags: this.selectValue
      })
    },
    // 改变评分
    scoreChange() {
      this.lowTagActive = []
      this.highTagActive = []
      this.selectValue = []
      this.$emit('change', {
        [this.prop]: this.score,
        tags: this.selectValue
      })
    }
  },
  watch: {
    tagValue: {
      handler: function(val) {
        if (!val) {
          return
        }
        this.lowTagValue = val.low
        this.highTagValue = val.high
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style lang="scss">
.evaluateTag {
  width: 100%;
  &-star {
    width: 100%;
    height: 0.64rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 0.453rem;
    .label {
      color: #333;
      font-size: 0.373rem;
      margin-right: 0.64rem;
      margin-left: 0.587rem;
    }
    .el-rate {
      height: 0.64rem;
      outline: none !important;
      border: none !important;
      .el-rate__icon {
        font-size: 0.64rem;
        margin-right: 0.4rem;
      }
    }
  }
  &-tags {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 0.533rem;
    .tagClass {
      padding: 0.213rem 0.267rem;
      background: #f1f8ff;
      text-align: center;
      font-size: 0.32rem;
      color: #666;
      margin-right: 0.267rem;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
      border-radius: 35px;
    }
    .activeTagClass {
      background: #70baff;
      color: #fff;
      padding: 0.213rem 0.267rem;
      text-align: center;
      font-size: 0.32rem;
      margin-right: 0.267rem;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
      border-radius: 35px;
    }
  }
}
</style>
